<template>
  <div class="links">
    <strong>{{ label || $tc('link', 2) }}</strong>
    <div class="links__list" v-for="(item, index) in value" :key="index">
      <a :href="item.url" target="_blank">
        <strong class="links__icon">
          <FontAwesomeIcon :icon="['far', 'link']"></FontAwesomeIcon>
        </strong>
        <slot name="title">
          <span>
            {{ item.name }}
          </span>
        </slot>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.links {
  $spacing: 1rem;
  &__list {
    margin-top: 0.5rem;

    a {
      text-decoration: none;
      color: $dark;
      font-weight: bold;
      line-height: 1;
      position: relative;
      display: flex;
      align-items: center;
      padding: $spacing;
      border: 1px solid $border-color;
      border-radius: $border-radius;
      background-color: white;
    }
  }

  &__icon {
    font-size: 1.5em;
    margin-right: $spacing;
    opacity: 0.5;
  }
  &__name {
    font: inherit;
    font-weight: bold;
    transition: background-color 150ms ease-out;
    color: inherit !important;
    border: none;
    border-radius: $border-radius;
    background-color: transparent;
    &:hover:not(:disabled) {
      // background-color: lighten(GetVariable('border-color'), 5%);
      background-color: $border-color;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    &-footer {
      display: flex;
      align-items: center;
      margin-top: 0.2rem;
    }
  }
}
</style>
